module.exports = __webpack_public_path__ + "img/57.978d7ba7.jpg";